import { Configuration } from "@sdk/configuration"
import { getToken } from "@clerk/vue"

/**
 * Get API configuration for the Klantportaal
 * Uses Clerk authentication tokens and automatically extracts data from responses
 */
export function getApiConfiguration(): Configuration {
  return new Configuration({
    basePath: import.meta.env.VITE_API_URL || "http://localhost:8000",
    accessToken: async () => {
      // Get the token from Clerk
      const token = await getToken()
      return token || ""
    },
    baseOptions: {
      params: {
        normalize: false,
        get_nested: true
      },
      // Parse JSON responses
      transformResponse: [
        (data: any) => {
          if (typeof data === "string") {
            try {
              data = JSON.parse(data)
            } catch {
              /* Ignore */
            }
          }
          return data
        }
      ]
    }
  })
}
